import { SimpleError } from "@simonbackx/simple-errors";
export class EnumDecoder {
    constructor(e) {
        this.enum = e;
    }
    decode(data) {
        let str;
        try {
            str = data.string;
            if (Object.values(this.enum).includes(str)) {
                return str;
            }
        }
        catch (e) {
            try {
                str = data.number;
                if (Object.values(this.enum).includes(str)) {
                    return str;
                }
            }
            catch (e2) {
                throw new SimpleError({
                    code: "invalid_field",
                    message: `Expected a number or string for enum: ` + Object.values(this.enum).join(", "),
                    field: data.currentField,
                });
            }
        }
        throw new SimpleError({
            code: "invalid_field",
            message: "Unknown enum value " + str + " expected " + Object.values(this.enum).join(", "),
            field: data.currentField,
        });
    }
}
//# sourceMappingURL=EnumDecoder.js.map